import { watch } from 'vue'
import { useAppLocale } from '@/composables/use-app-locale'

export default {
  setup() {
    const { setInitialAppLanguage, changeAppLanguage } = useAppLocale()
    const { locale } = useI18n()

    setInitialAppLanguage()

    watch(locale, changeAppLanguage)
  },
  render: () => {},
}
